var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.722 8.053 7.467 18.388-3.38 1.997-.105.037c-2.313.799-6.64.926-9.223-3.132-1.4-2.2-1.23-4.282-.513-5.913.419-.955 1.02-1.75 1.576-2.348L2 10.53l1.462-1.684 9.478 8.23-1.03.837c-.525.427-1.408 1.297-1.899 2.413-.462 1.055-.589 2.338.353 3.818 1.779 2.795 4.724 2.835 6.512 2.256l1.524-.901-7.472-18.4.824-.49a34.748 34.748 0 0 1 3.017-1.588c.576-.265 1.17-.513 1.722-.697.527-.175 1.11-.325 1.63-.325a6.2 6.2 0 0 1 3.703 1.262c1.282.983 2.283 2.583 2.535 4.978.295 2.798-.796 4.7-1.964 5.787L30 22.56l-1.453 1.69-10.057-8.637 1.645-.705c.657-.282 2.306-1.598 2.007-4.434-.194-1.843-.921-2.864-1.675-3.442a3.97 3.97 0 0 0-2.346-.802c-.149 0-.453.055-.924.212-.446.148-.96.36-1.494.606a31.67 31.67 0 0 0-1.98 1.005z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRev);
export default __webpack_public_path__ + "static/media/REV.6912b6830ee4a8cb0477157c1d0d0f70.svg";
export { ForwardRef as ReactComponent };